/* eslint-disable no-eval */
export const evaluate = (stringCode) => {
  return eval(`${stringCode}`);
};
